import { DeviceCompatibilityLevel, DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

import { PropertyPanelDevice } from './property-panel-device.model';

/**
 * Model that represents the minimum useful subset of properties shared between inventory and property
 * panel devices.
 */
export interface PartialDevice {
	id: string;
	compatibility?: DeviceCompatibilityLevel;
	deviceState?: DeviceStatus;
	status?: DeviceStatus;
	features: Partial<
		Pick<
			PropertyPanelDevice['features'],
			| 'authentication'
			| 'availablePackages'
			| 'identify'
			| 'firmware'
			| 'hostedFirmware'
			| 'micStatus'
			| 'mute'
			| 'name'
			| 'reboot'
			| 'rfChannels'
			| 'updateProgress'
			| 'hostedUpdateProgress'
		>
	>;
}

/**
 * Utility function to get the device state regardless of which actual device model is provided.
 * TODO: Rename device state fields on inventory and property panel devices so they match.
 */
export function getDeviceState(device: PartialDevice): DeviceStatus {
	return device.deviceState ?? device.status ?? DeviceStatus.Error;
}
